import { connect } from 'react-redux'
import { compose, lifecycle, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import { getIsTrailer } from 'helpers/vehicle'
import BOTYourVehicle from './BOTYourVehicle'
import { setVehiclesList } from '../../QuickAppointmentPage/actions'
import { showNewShopTiresModal } from '../../NewShopTiresModal/actions'
import { YMME_NAME, GENERAL_SOURCE } from 'constant'

export default compose(
  withType({ type: 'BOTYourVehicle' }),
  connect(null, { setVehiclesList, showNewShopTiresModal }),
  withProps(
    ({
      activeVehicle: {
        noOfVehicles,
        userVehicle,
        userVehicle: [{
          vehicleType
        } = {}] = []
      } = {},
      showNewShopTiresModal
    }) => ({
      noOfVehicles,
      userVehicle: userVehicle || [],
      isTrailer: getIsTrailer({ vehicleType }),
      addNewVehicle: () => showNewShopTiresModal({
        isOnlyVehicle: true,
        ymmeName: YMME_NAME,
        withShowConfirmTireSizeModal: true,
        source: GENERAL_SOURCE
      })
    })
  ),
  lifecycle({
    componentDidMount() {
      const { userVehicle, setVehiclesList } = this.props

      if (userVehicle && userVehicle.length) {
        setVehiclesList(userVehicle)
      }
    },
    UNSAFE_componentWillReceiveProps({ userVehicle: newVehiclesList = []}) {
      if (newVehiclesList.length) {
        this.props.setVehiclesList(newVehiclesList)
      }
    },

    componentWillUnmount() {
      this.props.setVehiclesList([])
    }
  })
)(BOTYourVehicle)
